<template>
  <div class="container">
    <header>
      <!-- <a href="https://www.iczhiku.com" class="index">&lt; 返回首页</a> -->
      <!-- <router-link to="/" class="index">
        <img src="/static/logo.png" alt="logo_IC智库" />
      </router-link> -->
      <div class="navbar">
        <router-link to="/" exact :class="{active:!($route.path && $route.path!='/')}">教学课程</router-link>
        <!-- <router-link to="/continue">进阶课程</router-link> -->
        <router-link to="/program">专题课程</router-link>
        <router-link to="/practical">实战课程</router-link>
        <router-link to="/vrpractice">VR实操课程</router-link>
        <router-link to="/employment">就业班课程</router-link>
      </div>
      <span @click="loginState=true" v-if="!loginStatus">登录</span>
      <!-- <router-link to="/student"><img class="headImg" :src="headerImg" v-if="headerImg" /></router-link> -->
      <div class="headImage" v-if="loginStatus">
        <span>已登录</span>
        <div class="hidden">
          <router-link :to='{name:loginStatus==1?"tearcher":"student"}' tag="div">个人中心</router-link>
          <div @click="_logout">退出</div>
        </div>
      </div>
    </header>
    <div id="register" @click="loginState=false" v-if="loginState">
      <div class="frame" @click.stop>
        <div class="head">
          <img src="/static/logo.png" style="opacity:0"/>
          <span class="zh-remove" @click="loginState=false"></span>
        </div>
        <div class="content">
          <input
            type="text"
            class="phone"
            placeholder="请输入您的手机号码"
            v-model="phone"
            @focus="codes=false"
          />
          <p></p>
          <input
            type="text"
            class="code"
            placeholder="请输入手机验证码"
            v-model="code"
            @keyup.enter="_login"
          />
          <button class="buttonCode" @click="_sendSMS" ref="code">{{seconds}}</button>
          <p>{{message}}</p>
          <button @click="_login()">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendSMS, phoneLogin, logout } from "@/assets/js/axios.js";
export default {
  name: "headers",
  data() {
    return {
      loginState: false,
      seconds: "发送验证码",
      phone: "",
      code: "",
      message: "",
      activeStatus: this.$route.path,
      loginStatus: this.cookieVue.getCookie("loginStatus")
    };
  },
  watch: {
    "$route"() {
      console.log(323223)
      this.loginState = true
    }
  },
  methods: {
    _logout() {
      logout().then(res => {
        if (res.code == 1) {
          this.loginStatus = false;
          this.$message({
            message: "退出成功",
            type: "success"
          });
        }
      })
    },
    _sendSMS() {
      if (this.phone) {
        if (this.seconds === "发送验证码" || this.seconds === "重新发送") {
          this.seconds = "60s";
          let that = this;
          this.$refs.code.style.background = "#ddd";
          let seconds = setInterval(() => {
            let x = parseInt(that.seconds);
            that.seconds = --x + "s";
            if (that.seconds === "0s") {
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          }, 1000);
          sendSMS(this.phone).then(data => {
            if (parseInt(data.code) !== 1) {
              this.message = data.msg || "未知错误，请重试";
              that.seconds = "重新发送";
              clearInterval(seconds);
              this.$refs.code.style.background = "#109eff";
            }
          });
        }
      } else {
        this.message = "请输入您的手机号码";
      }
    },
    _login() {
      if (!this.phone) {
        this.message = "请输入您的手机号码";
        return;
      }
      if (!this.code) {
        this.message = "请输入手机验证码";
        return;
      }
      phoneLogin(this.phone, this.code).then(data => {
        if (parseInt(data.code) === 1) {
          if (this.cookieVue.getCookie("loginStatus") == 1) {
            this.$router.push({ name: "tearcher" });
          } else {
            this.$router.push({ name: "student" });
          }
          this.loginState = false;
        } else {
          this.message = data.msg || "未知错误请重试";
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background: #fff;
  box-shadow: 1px 1px 2px #c7c7c7;
  header {
    width: 1200px;
    height: 76px;
    margin: 0 auto;
    position: relative;
    font-size: 0;
    .index {
      position: absolute;
      color: #109eff;
      line-height: 76px;
      font-size: 16px;
      img {
        margin-top: 11px;
        width: 118px;
        height: 44px;
      }
    }
    .navbar {
      line-height: 76px;
      text-align: center;
      color: #333;
      font-size: 0;
      a {
        display: inline-block;
        font-size: 20px;
        padding: 0 25px;
        margin: 0 15px;
        height: 74px;
        cursor: pointer;
      }
      .router-link-active,
      .active {
        color: #25a1fc;
        border-bottom: 2px solid #25a1fc;
      }
    }
    >span {
      background: #109eff;
      width: 80px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      color: #fff;
      position: absolute;
      top: 23px;
      cursor: pointer;
      border-radius: 4px;
      font-size: 14px;
      right: 0px;
    }
    .headImage {
      right: 0px;
      width: 179px;
      height: 40px;
      position: absolute;
      top: 19px;
      overflow: hidden;
      transition: height 0.2s;
      font-size: 14px;
      span {
        background: #109eff;
        width: 80px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        position: absolute;
        top: 4px;
        cursor: pointer;
        border-radius: 4px;
        font-size: 14px;
        right: 0px;
      }
      .hidden {
        margin-top: 58px;
        text-align: center;
        padding: 0 8px;
        width: 103px;
        height: 114px;
        box-shadow: 1px 1px 3px rgb(224, 224, 224),
          -1px -1px 3px rgb(224, 224, 224);
        border-radius: 8px;
        position: relative;
        left: 60px;
        z-index: 1;
        background: #fff;
        overflow: hidden;
        color: #333;
        div {
          line-height: 56px;
          border-bottom: 1px solid rgb(229, 229, 229);
          cursor: pointer;
        }
        div:hover {
          color: #109eff;
        }
      }
    }
    .headImage:hover {
      height: 172px;
    }
  }
  #register {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 100;
    font-size: 0;
    .frame {
      width: 426px;
      height: 346px;
      background: #fff;
      border-radius: 10px;
      position: relative;
      top: 50%;
      left: 50%;
      margin-left: -213px;
      margin-top: -173px;
      .head {
        height: 42px;
        padding: 30px 30px 10px;
        color: #109eff;
        img {
          width: 95px;
          height: 35px;
        }
        span.zh-remove {
          display: inline-block;
          position: relative;
          width: 16px;
          height: 16px;
          top: -20px;
          left: 266px;
          cursor: pointer;
        }
        span.zh-remove:before {
          display: block;
          content: "";
          position: absolute;
          width: 2px;
          height: 16px;
          background: #aaa;
          transform: rotate(-45deg);
        }
        span.zh-remove:after {
          display: block;
          content: "";
          position: absolute;
          width: 2px;
          height: 16px;
          background: #aaa;
          transform: rotate(45deg);
        }
      }
      .content {
        margin-top: 16px;
        padding: 0 30px;
        input {
          border: 1px solid #d1d1d1;
          outline: none;
          border-radius: 4px;
          padding-left: 16px;
          width: 350px;
          height: 38px;
        }
        input:focus {
          border-color: #109eff;
        }
        input.code {
          width: 230px;
        }
        p {
          height: 20px;
          padding-top: 4px;
          font-size: 12px;
          color: red;
          text-align: center;
        }
        button {
          width: 366px;
          height: 40px;
          background: #109eff;
          border: none;
          border-radius: 4px;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          outline: none;
          margin-top: 10px;
        }
        .buttonCode {
          width: 108px;
          height: 40px;
          margin-left: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/header.vue